var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTableLarge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "Icon-fill-color",
    stroke: "transparent",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.25659 5.5C1.25659 5.08579 1.59238 4.75 2.00659 4.75H22.0066C22.4208 4.75 22.7566 5.08579 22.7566 5.5C22.7566 5.91421 22.4208 6.25 22.0066 6.25H2.00659C1.59238 6.25 1.25659 5.91421 1.25659 5.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "Icon-fill-color",
    stroke: "transparent",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.25659 8.5C2.25659 8.08579 2.59238 7.75 3.00659 7.75H21.0066C21.4208 7.75 21.7566 8.08579 21.7566 8.5C21.7566 8.91421 21.4208 9.25 21.0066 9.25H3.00659C2.59238 9.25 2.25659 8.91421 2.25659 8.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "Icon-fill-color",
    stroke: "transparent",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2566 18.5V5.5H21.7566V18.5C21.7566 18.9142 21.4208 19.25 21.0066 19.25C20.5924 19.25 20.2566 18.9142 20.2566 18.5Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "Icon-fill-color",
    stroke: "transparent",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.25659 18.5V5.5H3.75659V18.5C3.75659 18.9142 3.42081 19.25 3.00659 19.25C2.59238 19.25 2.25659 18.9142 2.25659 18.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableLarge);
export default __webpack_public_path__ + "static/media/TableLarge.4cf55e2e0e73a6f214329367ee8902c9.svg";
export { ForwardRef as ReactComponent };